export default __webpack_public_path__ + "static/media/womanB.afa1b640.png";